import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDroppable } from '@dnd-kit/core';
import { ReactNode } from 'react';
interface BlockDropZoneProps {
  droppableId: string;
  emptyHint?: string;
  children: ReactNode;
  minHeight?: number;
}

export default function BlockDropZone({
  droppableId,
  emptyHint,
  children,
  minHeight = 48,
}: BlockDropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({ id: droppableId });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        minHeight,
        borderRadius: 1,
        bgcolor: isOver ? 'action.hover' : 'transparent',
        transition: theme => theme.transitions.create('background-color'),
      }}
      data-testid={`block-drop-zone-${droppableId}`}
    >
      {children}
      {emptyHint ? (
        <Typography variant="body2" color="text.secondary">
          {emptyHint}
        </Typography>
      ) : null}
    </Box>
  );
}
